export const GalleryAnswerContainerStyles = () => `
  flex: 1;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 16px;
`;

export const GalleryAnswerPhotoContainerStyles = () => `
  aspect-ratio: ${4 / 3};
  border-radius: 11px;
  overflow: hidden;
  display: flex;
  margin-right: 12px;
  width: 104px;
`;

export const GalleryAnswerPhotoStyles = () => `
  height: 100%;
  width: 100%;
`;

export const GalleryAnswerFailIconContainerStyles = () => `
  padding: 0;
`;
